import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp, FaEye, FaEyeSlash, FaEdit } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { sendApiRequest } from '../utils';
import Loader from './Loader'

const VehicleTable = ({ data }) => {
  const [isDataVisible, setIsDataVisible] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [isBulkDataVisible, setIsBulkDataVisible] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editedData, setEditedData] = useState({ ...data });
  const [imagePreviews, setImagePreviews] = useState({});

  console.log("Data", data);

  const nonEditableFields = ["vehicleNumber", "_id", "engineNo", "ChassisNo"];
  const imageFields = [
    "ownerAadharImage",
    "ownerPanImage",
    "rcImage",
    "licenseImage",
    "aadharImage"
  ];

  const handleToggle = () => {
    setIsDataVisible(!isDataVisible);
  };

  const handleBulkToggle = () => {
    setIsBulkDataVisible(!isBulkDataVisible);
  };

  const uploadToCloudinary = async (fileBase64) => {
  const formData = new FormData();
  formData.append("file", fileBase64);
  formData.append("upload_preset", "prayagproperties");

  const response = await fetch(
    "https://api.cloudinary.com/v1_1/djmyigser/image/upload",
    {
      method: "POST",
      body: formData,
    }
  );

  const data = await response.json();
  if (!data.secure_url) {
    throw new Error("Cloudinary upload failed");
  }

  return data.secure_url;
};


  const handleEdit = async () => {
  if (editMode) {
    try {
      const updateData = { ...editedData };
      setisLoading(true);

      // Upload images in imagePreviews to Cloudinary and replace in updateData
      for (let field of imageFields) {
        if (imagePreviews[field]) {
          const imageUrl = await uploadToCloudinary(imagePreviews[field]);
          updateData[field] = imageUrl;
        }
      }

      // Remove non-editable fields
      nonEditableFields.forEach(field => delete updateData[field]);

      const response = await sendApiRequest(
        `api/trucks/update/${data._id}`,
        updateData,
        "PUT"
      );

      if (response.status === 200) {
        toast.success("Changes saved successfully!");
      } else {
        throw new Error(response.message || "Update failed!");
      }
    } catch (error) {
      console.error("Update Error:", error);
      toast.error("Error updating vehicle details");
    }

    setisLoading(false);
    setEditMode(false);
  } else {
    setEditedData({ ...data });
    setEditMode(true);
  }
};



  const handleInputChange = (key, value) => {
    setEditedData(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleImageUpload = (key, file) => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviews(prev => ({ ...prev, [key]: reader.result }));
        setEditedData(prev => ({ ...prev, [key]: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const renderValue = (value, key, isEditing) => {
  if (isEditing && !nonEditableFields.includes(key)) {
    if (imageFields.includes(key)) {
      return (
        <div className="flex flex-col gap-2">
          <input
            type="file"
            accept="image/*"
            onChange={(e) => handleImageUpload(key, e.target.files[0])}
            className="border p-1 rounded text-sm"
          />
          {(imagePreviews[key] || editedData[key]) ? (
            <div className="flex items-center gap-2">
              <img
                src={imagePreviews[key] || editedData[key]}
                alt={key}
                className="w-32 h-20 object-cover border"
              />
              <a
                href={imagePreviews[key] || editedData[key]}
                download={`${key}.png`}
                className="px-3 py-1 text-xs font-medium bg-green-500 text-white rounded hover:bg-green-600 transition"
              >
                ⬇️ Download
              </a>
            </div>
          ) : (
            <span className="text-gray-500 italic">No image uploaded</span>
          )}
        </div>
      );
    }

    return (
      <input
        type={typeof value === "number" ? "number" : "text"}
        value={value}
        onChange={(e) => handleInputChange(key, e.target.value)}
        className="w-full px-2 py-1 border rounded"
      />
    );
  }

  // Read-only mode for image fields
  if (imageFields.includes(key) && value) {
    let imageUrl = value;

    // Convert base64 (if missing prefix) to data URI
    if (!value.startsWith('data:image') && !value.startsWith('http')) {
      imageUrl = `data:image/png;base64,${value}`;
    }

    return (
      <div className="flex items-center gap-2">
        <img
          src={imageUrl}
          alt={key}
          className="w-32 h-20 object-cover border"
        />
        <a
          href={imageUrl}
          download={`${key}.png`}
          className="px-3 py-1 text-xs font-medium bg-green-500 text-white rounded hover:bg-green-600 transition"
        >
          ⬇️ Download
        </a>
      </div>
    );
  }

  return value?.toString() || "-";
};




  return (
    <div className="overflow-x-auto w-full bg-gray-50 py-4">
      <table className="w-full text-sm text-left text-gray-700 bg-white border border-gray-300 rounded-lg shadow-lg">
        <thead className="bg-blue-500 text-white uppercase text-xs">
          <tr>
            <th className="px-4 py-3 border text-left rounded-tl-lg">Field</th>
            <th className="px-6 py-3 border text-left">Value</th>
            <th className="px-4 py-3 border text-left rounded-tr-lg">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border hover:bg-blue-100 bg-gray-100">
            <td className="px-4 py-3 font-medium text-gray-900 border">vehicleNumber</td>
            <td className="px-6 py-3 border">{data.vehicleNumber}</td>
            <td className="px-4 py-3 text-blue-500 cursor-pointer border">
              <div className="flex gap-2">
                <button
                  onClick={handleToggle}
                  className="flex items-center gap-1 px-3 py-1 text-xs font-medium rounded bg-blue-500 text-white hover:bg-blue-600 transition-colors"
                >
                  {isDataVisible ? <FaChevronUp /> : <FaChevronDown />}
                  {isDataVisible ? 'Hide' : 'Show'}
                </button>
                <button
                  onClick={handleEdit}
                  className={`flex items-center gap-1 px-3 py-1 text-xs font-medium rounded ${editMode ? 'bg-green-500 hover:bg-green-600' : 'bg-yellow-500 hover:bg-yellow-600'
                    } text-white transition-colors`}
                >
                  <FaEdit />
                  {editMode ? isLoading?<Loader/>:'Save' : 'Edit'}
                </button>
              </div>
            </td>
          </tr>
          {isDataVisible &&
            Object.keys(data).map((key) => {
              if (key === 'vehicleNumber') return null;
              if (key === 'bulkData') {
                return (
                  <tr key={key} className="border hover:bg-gray-50">
                    <td className="px-4 py-3 font-medium text-gray-900 border">{key}</td>
                    <td className="px-6 py-3 border">
                      {isBulkDataVisible ? (
                        <pre className="text-sm text-gray-600 whitespace-pre-wrap">
                          {JSON.stringify(data[key], null, 2)}
                        </pre>
                      ) : (
                        <span className="text-gray-500 italic">Click "Show" to view details</span>
                      )}
                    </td>
                    <td className="px-4 py-3 border">
                      <button
                        onClick={handleBulkToggle}
                        className="flex items-center gap-1 px-3 py-1 text-xs font-medium rounded bg-purple-500 hover:bg-purple-600 text-white transition-colors"
                      >
                        {isBulkDataVisible ? <FaEyeSlash /> : <FaEye />}
                        {isBulkDataVisible ? 'Hide' : 'Show'}
                      </button>
                    </td>
                  </tr>
                );
              }
              return (
                <tr key={key} className="border hover:bg-gray-50">
                  <td className="px-4 py-3 font-medium text-gray-900 border">{key}</td>
                  <td className="px-6 py-3 border">{renderValue(editedData[key], key, editMode)}</td>
                  <td className="px-4 py-3 border">-</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default VehicleTable;
